module.exports = __webpack_public_path__ + "static/media/logo-biblioteca-teresiana.58d880e4.svg";